module.exports = __webpack_public_path__ + "img/inwards-agility.2a7074f9.png";